<template>
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <dr-process-component v-if="formioIsLoaded" v-bind="$props" />
  </dr-wrapper>
  <div v-else>
    <dr-process-component v-if="formioIsLoaded" v-bind="$props" @callDataSourceAction="$emit('callDataSourceAction', $event)"/>
  </div>
</template>

<script>
import drProcessComponent from './dr-process-component'
import baseMixin from '../../mixins/base-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import { installFormio } from '../../formio'

export default {
  name: 'dr-process-item',
  mixins: [baseMixin, widgetsWrapperMixin],
  components: {
    'dr-process-component': drProcessComponent
  },
  data: () => ({
    formioIsLoaded: false
  }),
  async created() {
    await installFormio()
    this.formioIsLoaded = true
  }
}
</script>